import type { ComponentChildren } from 'preact';
import { SectionHeading, type SectionHeadingProps } from './SectionHeading';

/**
 * The canonical section-header strip across the platform. Composes a SectionHeading on the
 * left and an `actions` slot on the right.
 */
export interface SectionTitleBarProps {
  eyebrow?: SectionHeadingProps['eyebrow'];
  title: SectionHeadingProps['title'];
  subtitle?: SectionHeadingProps['subtitle'];
  size?: SectionHeadingProps['size'];
  as?: SectionHeadingProps['as'];
  actions?: ComponentChildren;
  bare?: boolean;
  class?: string;
}

export function SectionTitleBar({
  eyebrow,
  title,
  subtitle,
  size = 'lg',
  as,
  actions,
  bare = false,
  class: extraClass,
}: SectionTitleBarProps) {
  const dividerClasses = bare ? '' : 'mb-8 border-b border-rule pb-6';
  return (
    <header class={`flex flex-wrap items-end justify-between gap-6 ${dividerClasses} ${extraClass ?? ''}`}>
      <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} size={size} as={as} />
      {actions && <div class="flex shrink-0 items-center gap-4 font-mono">{actions}</div>}
    </header>
  );
}
